import { isComposing } from "#ce/utils/events";

/**
 * Returns the index of the first label that starts with `query`, searching from `from` and
 * wrapping, or -1 when none does. Both sides are lowercased before comparing, and a numeric
 * label is compared as its digits.
 *
 * @param {Array<string|number|null>} labels - One label per navigable row, in navigation order.
 *   A null entry never matches, which is how a row that cannot be a target is skipped.
 * @param {string} query - Lowercase.
 * @param {number} from - Index to start at.
 * @returns {number}
 */
export function findTypeAheadMatch(labels, query, from) {
  for (let offset = 0; offset < labels.length; offset++) {
    const index = (((from + offset) % labels.length) + labels.length) % labels.length;
    const label = labels[index];

    if (label != null && String(label).toLowerCase().startsWith(query)) {
      return index;
    }
  }

  return -1;
}

/**
 * Returns whether the keystroke is one a visitor typed to search: a single printable character
 * with no modifier, typed outside an IME composition. Space stays selection, and Tab, Escape and
 * the arrows stay navigation.
 *
 * @param {KeyboardEvent} event
 * @returns {boolean}
 */
export function isTypeAheadKey(event) {
  if (isComposing(event)) {
    return false;
  }

  return event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey && event.key !== " ";
}
